import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import { useModal } from 'components/modals/ModalContext';
import DemoEnvironmentProgressModal from './DemoEnvironmentProgressModal';

/*
 * DemoEnvironmentForm.tsx
 * Form to create a sales demo environment with a name, a sector and a
 * package. After the creation the progress modal of the demo data
 * creation is opened, which shows the demo login when it is done.
 */

const DemoEnvironmentForm: React.FC<{ viewKey?: string, onFinished?: () => void }> = ({ viewKey, onFinished }) => {
    const { initializeModal } = useModal();

    const apiObject = 'demo_environment_as_superuser'

    // Open the progress modal of the created demo environment
    const handleOpenProgressModal = (data?: Record<string, any>) => {
        if (!data?.id) return;
        initializeModal(
            <DemoEnvironmentProgressModal
                demoEnvironmentId={data.id}
                name={data.name}
                loginEmail={data.login_email}
                onFinished={onFinished}
            />,
            { modalSize: 'small' }
        );
    };

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'demo_environment.general.name_label',
            type: 'text',
            placeholder: 'demo_environment.general.name_placeholder',
        },
        {
            name: 'industry',
            label: 'demo_environment.general.industry_label',
            type: 'dropdown',
            disabled_selected: 'forms.select_type_disabled_selected',
            showSearch: false,
            allowNoneOption: false,
            hardcodedOptions: [
                { value: 'installation_technical', name: 'trial.industry.installation_technical' },
                { value: 'security_access', name: 'trial.industry.security_access' },
                { value: 'blinds', name: 'trial.industry.blinds' },
                { value: 'interior_finishing', name: 'trial.industry.interior_finishing' },
                { value: 'construction_renovation', name: 'trial.industry.construction_renovation' },
                { value: 'equipment_machinery', name: 'trial.industry.equipment_machinery' },
                { value: 'signage_visual', name: 'trial.industry.signage_visual' },
                { value: 'landscaping_outdoor', name: 'trial.industry.landscaping_outdoor' },
                { value: 'facility_services', name: 'trial.industry.facility_services' },
                { value: 'other', name: 'trial.industry.other' },
            ],
        },
        {
            name: 'package',
            backendField: 'key',
            label: 'demo_environment.general.package_label',
            type: 'dropdown',
            disabled_selected: 'forms.select_type_disabled_selected',
            showSearch: false,
            allowNoneOption: false,
            apiRequest: [{
                endpoint: 'get_subscription_package_list',
                object: 'subscription_package',
                params: { is_active: true },
                useCache: true
            }],
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            onSuccess={handleOpenProgressModal}
        />
    );
};

export default DemoEnvironmentForm;
